export * from "@/ui/components/sections/marketing/NewsletterSignUp/NewsletterSignup";
export * from "@/ui/components/sections/marketing/NewsletterSignUp/NewsletterSignup.config";
